import { CONFIG_BTN_MELODY } from "../constants/game"
import { assetsImageLoader } from "../utils/funtions"



export default class BtnMelody {
  /** @type Phaser.GameObjects.Container */
  mainContainer
  /**
   * @type {{
   *  context: Phaser.Scene
   *  handleOnClick: Function
   * }}
   */
  config = {}

  /**
   *
   * @param {Phaser.Scene} context
   * @param {Function} handleOnClick
   */
  constructor(context) {
    this.config.context = context
    this.state = {
      on: true
    }
  }

  preload() {
    const assetsToLoad = {
      'on': CONFIG_BTN_MELODY.on,
      'off': CONFIG_BTN_MELODY.off
    }

    assetsImageLoader(
      assetsToLoad,
      'melody-',
      this.config.context
    )
  }

  create() {

    this.ID_CAM_FILTER = this.config.context.cameras.getCamera('minimap').id;

    this.imgIdle = this.config.context.add
      .image(
        0,
        0,
        `melody-on`
      )
      .setOrigin(0.5).setScrollFactor(0).setDepth(1);

    this.imgActive = this.config.context.add
      .image(
        0,
        0,
        `melody-off`
      )
      .setOrigin(0.5).setScrollFactor(0).setDepth(1).setVisible(false);


    var interactiveZone = this.config.context.add.zone(0, 0,
      this.imgIdle.width, this.imgIdle.height)
      .setRectangleDropZone(this.imgIdle.width, this.imgIdle.height)
      .setOrigin(.5)
      .setScrollFactor(0)
      .setDepth(3).setInteractive().on('pointerover', () => {
        this.config.context.cursor.set("pointer")
      })
      .on('pointerout', () => {
        this.config.context.cursor.default();
      }).on('pointerdown', () => {
        this.style_isPressed();
        const handlerPointerUpGlobal = () => {
          this.style_isReleased();
          this.config.context.input.off('pointerup', handlerPointerUpGlobal);
        }
        this.config.context.input.on('pointerup', handlerPointerUpGlobal)
      }).on('pointerup', () => {
        this.handlePressButton();
      })

    this.mainContainer = this.config.context.add.container(
      this.getGameWSize() - CONFIG_BTN_MELODY.marginRight[this.config.context.data.get('mediaType')],
      CONFIG_BTN_MELODY.marginTop[this.config.context.data.get('mediaType')],
      [this.imgIdle, this.imgActive, interactiveZone]).setDepth(100).setScrollFactor(0);
    this.mainContainer.cameraFilter = this.ID_CAM_FILTER

  }
  getGameWSize() {
    return this.config.context.game.scale.width
  }

  isMuted() {
    return !this.state.on;
  }


  style_isPressed() {
    this.mainContainer.setScale(1.2);
  }
  style_isReleased() {
    this.mainContainer.setScale(1);
  }

  handlePressButton() {


    this.toggleMelodyMute();
  }
  toggleMelodyMute() {
    this.state.on = !this.state.on;
  }
  update() {

    this.imgIdle.setVisible(this.state.on);
    this.imgActive.setVisible(!this.state.on);
  }
}
